<template>
  <div>
    <v-tooltip right>
      <v-btn
        icon
        absolute
        left
        style="top:10px"
        slot="activator"
        @click="$emit ('selectComponantes','transferListTable')"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <span>Back</span>
    </v-tooltip>
    <transferRateForm
      :edit_form="edit_form"
      :dialog="transferRateDialog"
      @setDialog="transferRateDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
    />
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search end point"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="is_loading_price"
      :items="end_transfer_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ end_transfer_list.indexOf(props.item)+1 }}</td>
        <td class="text-xs-center">{{ select_start.transport_sub_district_start_name }}</td>
        <td class="text-xs-center">{{ props.item.transport_sub_district_start_name }}</td>
        <td class="text-xs-center" v-if="is_loading_price">Calculating ..</td>
        <td
          class="text-xs-center"
          v-else
        >{{ props.item.transport_price == 0 ? props.item.transport_price : !props.item.transport_price || props.item.transport_price == null ? 'Not set' : props.item.transport_price }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top v-if="!isEditTransfer">
            <v-btn icon @click="editTransferRate(props.item)" slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import transferRateForm from "./TransferRateForm";
export default {
  data: () => ({
    search: "",
    edit_form: {},
    transferRateDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 10
    },
    headers: [
      {
        text: "#",
        align: "center",
        sortable: false,
        value: "name"
      },
      {
        text: "Start point",
        align: "center",
        value: "role",
        sortable: false
      },
      {
        text: "End point",
        align: "center",
        value: "transport_sub_district_start_name",
        sortable: false
      },
      {
        text: "Transfer price",
        align: "center",
        value: "transport_price",
        sortable: false
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false
      }
    ]
  }),
  components: {
    transferRateForm
  },
  computed: {
    ...mapState({
      select_start: state => state.fetchFoodRateBack.select_start,
      end_transfer_list: state => state.fetchFoodRateBack.end_transfer_list,
      is_loading_price: state => state.fetchFoodRateBack.is_loading_price,
      transfer_set_list: state => state.fetchFoodRateBack.transfer_set_list
    }),
    ...mapGetters({
      isEditTransfer: "isEditTransfer"
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {},

  methods: {
    editTransferRate(item) {
      this.edit_form = item;
      this.transferRateDialog = true;
      this.editedIndex = 1;
    }
  }
};
</script>

